module.exports = __webpack_public_path__ + "static/zelt3-5b21851a49dc4f568f53d84aa59d9c7a.jpg";